export var HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
export var PRODUCT_HOME_BREAKPOINT = 1280;
export var CREATE_BREAKPOINT = 1130;
//# sourceMappingURL=constants.js.map